import * as types from "./mutation-type";

export default {
  [types.SET_PRODUCTS](state, payload) {
    state.products = payload
  },

  [types.SET_QUANTITY_FRACTIONAL](state, payload) {
    state.quantityFractional = Number(payload.toFixed(2))
    state.item.pro_price_site = state.bkpProduct.pro_price_site * state.quantityFractional
    if (state?.item?.price_to) {
      state.item.price_to = state.bkpProduct.price_to * state.quantityFractional
    }
  },

  [types.SET_MINIMUM_QUANTITY_FRACTIONAL](state, payload) {
    let factor = Number(payload.fractional_conversion_factor);
    let min = Number(
      factor > payload.fractional_minimum_sale ?
        factor : payload.fractional_minimum_sale
    )
    let mod = min % factor
    if (mod != 0) {
      if((factor - mod) <= mod) {
        min += (factor - mod);
      }
    }
    state.minimumQuantityFractional = min;
  },

  [types.SET_RESET_ITEMS_GRID](state, payload) {
    state.resetItemsGrid = payload
  },

  [types.SET_QUANTITY](state, payload) {
    state.quantity = payload
  },

  [types.SET_AVAILABILITY](state, payload) {
    state.availability = payload
  },

  [types.SET_FLAVORS](state, payload) {
    state.flavors = payload
  },

  [types.SET_MINIMUM_QUANTITY](state, payload) {
    let min = (state?.item?.quantity_conversion_factor > state?.item?.minimum_sale_quantity ?
      state.item.quantity_conversion_factor : state.item.minimum_sale_quantity)

    state.minimumQuantity =
      state?.item?.quantity_per_box && state.conversionUnitWhenSellingWithClosedBox == 'CX' ?
        (min > state.item.quantity_per_box ?
        (min % state.item.quantity_per_box == 0 ? min / state.item.quantity_per_box :
        (Math.trunc(min / state.item.quantity_per_box) + 1)) : 1) : min
    state.quantity = state.minimumQuantity
  },

  [types.SET_ITEM](state, payload) {
    state.item = payload
  },

  [types.SET_SETTINGS](state, payload) {
    state.settings = payload
  },

  [types.SET_ITEM_WISH](state, payload) {
      state.itemWish = payload
  },

  [types.SET_NUMBER_OF_BOXES_SELECTED](state, payload) {
    state.numberOfBoxesSelected = payload
  },

  [types.SET_CONVERSION_UNIT_WHEN_SELLING_WITH_CLOSED_BOX](state, payload) {
    state.conversionUnitWhenSellingWithClosedBox = payload
  },

  [types.SET_QUANTITY_PRODUCT_ITEMS_GROUP](state, payload) {
    state.quantityProductItemsGroup = payload
  },

  [types.SET_PRODUCT_PRICE_TO_BKP_DISCOUNT_CLOSED_BOX](state, payload) {
    state.product_price_to_bkp_discount_closed_box = payload
  },

  [types.SET_PRODUCT_PRO_PRICE_SITE_BKP_DISCOUNT_CLOSED_BOX](state, payload) {
    state.product_pro_price_site_bkp_discount_closed_box = payload
  },

  [types.SET_PRICE_PRODUCT](state, payload) {
    if (!payload) return

    let percentage_discount = 0
    let percentage_discount_by_user = state.item.percentage_discount_by_user
    let price_to = state.item.price_to
    let pro_price_site = state.item.pro_price_site

    let grid_price = payload.grid_price
    let pro_sale = state.item.pro_sale

    if (price_to > 0) {
      percentage_discount = 100 - price_to * 100 / pro_price_site
    }

    if (!price_to && !pro_sale) {
    let percentage_discount_user = grid_price - grid_price * percentage_discount_by_user / 100
    let commercial_discount_user = percentage_discount_user - percentage_discount_user * state.item.commercial_discount_by_user / 100
    let shipping_increase_user = commercial_discount_user - commercial_discount_user * state.item.financial_discount_by_user / 100
    pro_price_site = shipping_increase_user + shipping_increase_user * state.item.shipping_increase_user / 100
    }
    else {
        let percentage_discount_user = grid_price - grid_price * percentage_discount_by_user / 100
        pro_price_site = percentage_discount_user + percentage_discount_user * state.item.shipping_increase_user / 100
    }

    if (percentage_discount > 0) {
      price_to = pro_price_site - pro_price_site * percentage_discount / 100
    }

    state.item.pro_price_site = pro_price_site
    state.item.from_price_site = pro_price_site
    state.item.price_to = price_to
  },

  // PRODUCT
  [types.SET_RESET_PRODUCT](state, payload) {
    state.reset = payload;
  },

  [types.SET_BKP_PRODUCT](state, payload) {
    state.bkpProduct = payload;
  },

  // ADDITIONAL ITEMS
  [types.SET_ADDITIONAL_ITEMS](state, payload) {
    state.additionalItems = payload
  },

  [types.SET_ADDITIONAL_ITEMS_SELECTED](state, payload) {
    state.additionalItemsSelected = payload
  },

  [types.RESET_ADDITIONAL_ITEMS](state, payload) {
    state.additionalItemsSelected = null
  },

  // VARIATIONS
  [types.SET_VARIATIONS](state, payload) {
    state.variations = payload
  },

  [types.RESET_ACTIVE_VARIATIONS](state, payload) {
    state.variations.map(v => v.active = false);
  },

  [types.SET_ITEM_BY_VARIATION](state, payload) {
    if (!payload) {
      state.item = JSON.parse(JSON.stringify(state.bkpProduct));
      return;
    }
    state.item.id = payload.id;
    state.item.pro_price_site = payload.pro_price_site;
    state.item.price_to = payload.price_to;
    state.item.pro_stock_site = payload.pro_stock_site;
    state.item.image_main = payload.image_main;
    state.item.images = payload.images;
    state.item.sell_out_of_stock = payload.sell_out_of_stock;
    state.item.maximum_sale_quantity = payload.maximum_sale_quantity;
    state.item.minimum_sale_quantity = payload.minimum_sale_quantity;
    state.item.quantity_conversion_factor = payload.quantity_conversion_factor;
    state.item.out_of_stock_unavailable = payload.out_of_stock_unavailable;
    state.item.original_price = payload.original_price;
    state.item.price_on_request = payload.price_on_request;
    state.item.pro_sigla_medida = payload.pro_sigla_medida;
    state.item.med_desc = payload.med_desc;
    state.item.is_linked_products = payload.is_linked_products;
    state.item.pro_desc_min = payload.pro_desc_min;
    state.item.pro_description = payload.pro_description;
    state.item.ipi_percentage = payload.ipi_percentage;
  }
}
